var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12874_92675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.49316 14.5083L14.5073 9.49414",
    stroke: "#24282F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7471 7.93419L13.1022 5.5838C13.8094 4.88803 14.7628 4.4999 15.7549 4.50394C16.747 4.50798 17.6972 4.90387 18.3988 5.60537C19.1003 6.30687 19.4961 7.25715 19.5002 8.24922C19.5042 9.24129 19.1161 10.1948 18.4203 10.902L16.0652 13.2531",
    stroke: "#24282F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93517 10.7461L5.58478 13.1012C4.88901 13.8084 4.50087 14.7619 4.50491 15.7539C4.50895 16.746 4.90484 17.6963 5.60635 18.3978C6.30785 19.0993 7.25813 19.4952 8.2502 19.4992C9.24227 19.5032 10.1957 19.1151 10.9029 18.4193L13.2541 16.0642",
    stroke: "#24282F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12874_92675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.d82a768f85e51bf6217ac6c27cd1d11a.svg";
export { ForwardRef as ReactComponent };